import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

export const Calendar2Icon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 27 26">
            <path d="M1 5.34375C1 3.6869 2.34315 2.34375 4 2.34375H23C24.6569 2.34375 26 3.6869 26 5.34375V22C26 23.6569 24.6569 25 23 25H4C2.34315 25 1 23.6569 1 22V5.34375Z" strokeWidth="2" strokeLinejoin="round"/>
            <line x1="7.64502" y1="1" x2="7.64502" y2="3.6875" strokeWidth="2" strokeLinecap="round"/>
            <line x1="19.7422" y1="1" x2="19.7422" y2="3.6875" strokeWidth="2" strokeLinecap="round"/>
            <line x1="1" y1="8.375" x2="26" y2="8.375" strokeWidth="2" strokeLinejoin="round"/>
            <line x1="5.44092" y1="14" x2="7.74199" y2="14" strokeWidth="2" strokeLinecap="round"/>
            <line x1="12.3228" y1="14" x2="14.6238" y2="14" strokeWidth="2" strokeLinecap="round"/>
            <line x1="19.2041" y1="14" x2="21.5052" y2="14" strokeWidth="2" strokeLinecap="round"/>
            <line x1="5.44092" y1="19" x2="7.74199" y2="19" strokeWidth="2" strokeLinecap="round"/>
            <line x1="12.3228" y1="19" x2="14.6238" y2="19" strokeWidth="2" strokeLinecap="round"/>
            <line x1="19.2041" y1="19" x2="21.5052" y2="19" strokeWidth="2" strokeLinecap="round"/>
        </SvgIcon>
    );
}